import { Bag2, Box, Shop, Truck } from 'iconsax-react';

export const availabilityCalendarPriceTypes = {
    BASE: { label: 'پایه' },
    PEAK_HOUR: { label: 'ساعت پیک' }
} as const;

/** Days added to the estimated shipping date to form the end of the delivery range shown to the customer. */
export const SHIPPING_ESTIMATE_BUFFER_DAYS = 5;

export const SERVICE_TYPES = {
    INSTALL_CENTER: {
        priority: 1,
        label: 'تعویض در اتوسرویس',
        icon: Shop,
        id: 2,
        description: 'تعویض کالا در اتوسرویس انجام می‌شود',
        feeLabel: 'اجرت',
        disabled: false
    },
    PICKUP_CENTER: {
        priority: 4,
        label: 'تحویل حضوری',
        icon: Bag2,
        id: 4,
        description: 'تحویل کالا در مرکز فروشنده، بدون نصب',
        feeLabel: 'هزینه تحویل حضوری',
        disabled: false
    },
    INSTALL_ONSITE: {
        priority: 2,
        label: 'تعویض در محل مشتری',
        icon: Truck,
        id: 3,
        description: 'بازه‌های زمانی دلخواه - اعزام کارشناس',
        feeLabel: 'اجرت',
        disabled: false
    },
    SHIPPING: {
        priority: 3,
        label: 'ارسال توسط فروشنده',
        icon: Box,
        id: 1,
        description: 'تحویل ۱ تا ۳ روز کاری',
        feeLabel: 'هزینه ارسال',
        disabled: false
    }
};
